import { combineStateReducer } from "../utils/combineStateReducer";
import { State, Selector } from "./types";

import * as editPreferences from "./editPreferences";
import * as retrievePreferences from "./retrievePreferences";

const initialState: State = {
  editPreferences: editPreferences.initialState,
  retrievePreferences: retrievePreferences.initialState,
};

const reduceState = combineStateReducer(initialState, {
  editPreferences: editPreferences.reduceState,
  retrievePreferences: retrievePreferences.reduceState,
});

function createSelector(getState: () => State): Selector {
  return {
    ...editPreferences.createSelector(() => getState().editPreferences),
    ...retrievePreferences.createSelector(() => getState().retrievePreferences),
  };
}

export type { State, Selector };

export { reduceState, initialState, createSelector };
